export const CLIENT_ID_SET = 'Global/client-id-set';
export const CURRENT_BRAND_SET = 'Global/current-brand-set';
export const ENTERPRISE_BRAND_SET = 'Global/enterprise-brand-set';
export const IS_BRAND_FILTERABLE_SET = 'Global/is-brand-filterable-set';
export const IS_WHITELISTED_FOR_CAMPAIGNS_SET = 'Global/is-whitelisted-for-campaigns-set';
